export default {
  scoring: '/admin/scoring/:type',
  juzgados: '/admin/juzgados',
  motivos: '/admin/motivos',
  user: '/admin/user',
  personList: '/admin/person-list'
};
